import React, { useId } from 'react';
type RangeSliderProps = {
  label: string;
  unit: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (v: number) => void;
};
export function RangeSlider({
  label,
  unit,
  min,
  max,
  step = 1,
  value,
  onChange
}: RangeSliderProps) {
  const id = useId();
  const pct = (value - min) / (max - min) * 100;
  return <div data-id="element-659" data-mp="1h956rlf3u3rj">
      <div className="flex items-baseline justify-between" data-id="element-660" data-mp="1haoqxn3vsyyl">
        <label htmlFor={id} className="font-mono text-[10.5px] tracking-[0.14em] text-graphite" data-id="element-661" data-mp="24zr5un74sdpe">
          {label}
        </label>
        <p className="text-[20px] font-semibold tabular-nums tracking-[-0.02em] text-ink" data-id="element-662" data-mp="29zn8ai06jx2u">
          {value}
          <span className="ml-1 text-[12px] font-medium text-graphite" data-id="element-663" data-mp="1w4becctumamz">{unit}</span>
        </p>
      </div>
      <div className="relative mt-1 h-9" data-id="element-664" data-mp="2nxbv3vdt5eaj">
        <div className="absolute inset-x-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink/10" data-id="element-665" data-mp="2nw93tmckp9u3" />
        <div className="absolute left-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink" style={{
        width: `${pct}%`
      }} data-id="element-666" data-mp="2sotwulnnniwk" />
        <div className="pointer-events-none absolute top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-ink bg-white shadow-[0_2px_6px_rgba(28,29,34,0.18)]" style={{
        left: `${pct}%`
      }} aria-hidden="true" data-id="element-667" data-mp="11gfsa40r2ccm" />
        <input id={id} type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(Number(e.target.value))} className="precision-range absolute inset-0 h-full w-full cursor-pointer" aria-valuetext={`${value} ${unit}`} data-id="element-668" data-mp="16e7tjonabath" />
      </div>
      <div className="flex justify-between font-mono text-[9.5px] text-graphite/70" aria-hidden="true" data-id="element-669" data-mp="1p5qwjvhb6ovi">
        <span data-id="element-670" data-mp="3vvyhxftru98i">{min}</span>
        <span data-id="element-671" data-mp="3vvf1k3jrrswl">{max}</span>
      </div>
    </div>;
}